import { ChevronIcon, DoubleChevronIcon } from "pk-icons"
import { twMerge } from "tailwind-merge"

const ChevronButton = ({
  className,
  disabled,
  onClick,
  size = 14,
  direction = "left",
  isDouble = false
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={twMerge(
        `w-8 h-8 flex items-center justify-center rounded-lg transition`,
        className,
        disabled ? "opacity-30 cursor-not-allowed" : "hover:bg-gray-200 active:bg-gray-300"
      )}
    >
      {isDouble ? (
        <DoubleChevronIcon size={size} direction={direction} />
      ) : (
        <ChevronIcon size={size} direction={direction} />
      )}
    </button>
  )
}

export default ChevronButton
